export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const LOGINOTP = "loginotp";
export const LOGINPHONENUMBER = "loginphonenumber";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const CLEAR_ERROR = "clearError";
export const GET_EMAIL_CODE_INVIT = "EmailCodeInvit";
export const FORGOT_PASSWORD = "ForgotPassword";
export const RESET_PASSWORD = "resetPassword";
export const FETCH_SESSION = "fetchSession";
export const APPLICATION_GET_OR_CREATE = "applicationgetOrCreate";
export const CRITERIA_FORM_GET = "criteriaFormGet";
export const Innovations_FORM_GET = "innovationsFormGet";
export const STARTUP_INFORMATIONS_FORM_GET = "startupInformationsFormGet";
export const STARTUP_INFORMATIONS_FORM_SAVE = "startupInformationsFormSave";
export const FETCH_TEAMS = "FetchTeams";
export const GET_TEAM = "getTeam";
export const CRITERIA_FORM_SAVE_DRAFT = "criteriaSaveDraft";
export const SESSION_RESET_STATE = "sessionResetState";
export const Innovations_FORM_SAVE_DRAFT = "innovationsSaveDraft";
export const checklist_GET = "checklistGet";
export const UPDATE_STATUS_APPLICATION= "updateStatusApplication";
export const FA_QRCODE= "fa_qrcode";
//export const checklist_FORM_SAVE_DRAFT = "checklistSaveDraft";
export const ADD_TEAM = "addTeam";
export const EDIT_TEAM = "editTeam";
export const DELETE_TEAM = "deleteTeam";
export const MAKE_TEAM_LEAD = "makeTeamLead";

export const REQUEST_FORM_GET = "requestFormGet";
export const REQUEST_FORM_GET_DETAIL = "requestFormGetDetail";
export const REQUEST_FORM_SAVE_DRAFT = "requestSaveDraft";
export const REQUEST_FORM_UPDATE = "requestFormUpdate";
export const CLEAR_SAVE_MESSAGE = "clearSaveMessage"; 
export const FETCH_APPLICATION= "fetchApplication";
export const FETCH_APPLICATIONS = "fetchApplications";
export const CHECK_APPLY_MULTIPLE_APPLICATION = "checkApplyMultipleApplications";
export const SEND_INVITATION_TO_MEMBER = "sendInvitationToMember";

export const COMPANY_SAVE = "companySave";
export const CLEAR_DRAFT_FORM = "clearDraftForm";

export const REQUEST_LABEL_GET = "requestLabelGet";
export const GET_CURRENT_REQUESTS = "getCurrentRequests";
export const GET_COMPLETED_REQUESTS = "getCompletedRequests";
export const REQUEST_TEAM_GET = "requestTeamGet";
export const ADD_REQUEST_COMMENT = "addRequestComment";
export const GET_DECLARATIONS_REQUESTS = "getListRequestsDeclarations";
export const GET_INVESTORS_REQUESTS = "getInvestorsListDeclarations";
export const CHECK_INVESTORS_REQUESTS = "checkInvestorsDeclarations";
export const GET_CURRENT_REQUESTS_DECLARATIONS = "getCurrentRequestsDeclarations";
export const GET_COMPLETED_REQUESTS_DECLARATIONS = "getCompletedRequestsDeclarations";
export const REQUEST_DECLARATION_FORM_GET_DETAIL = "requestDeclarationFormGetDetail";
export const DECLARATION_FORM_UPDATE= "declarationFormUpdate";
export const ADD_DECLARATION_COMMENT= "addDeclarationComment";
export const RESEND_VERIFICATION_EMAIL= "resendVerificationEmail";
export const RESEND_OTP_CODE= "resendOtpCOde";
export const CHECK_LABEL = "checkLabel";
export const DELETE_FILE = "deleteFile";
export const PRELABEL_FORM_UPDATE = "prelabelFormUpdate";

// ECOSYSTEM ACTIONS
export const FETCH_ECOSYSTEM_APPLICATIONS = "fetchEcosystemApplications";
export const FETCH_ECOSYSTEM_APPLICATIONS_MAIR = "fetchEcosystemApplicationsmair";
export const FETCH_ECOSYSTEM_LABEL_REFS = "fetchEcosystemLabelRefs";
export const CREATE_ECOSYSTEM_APP = "createEcosystemApp";
export const CREATE_ECOSYSTEM_APP_MAIR = "createEcosystemAppMair";
export const DELETE_ECOSYSTEM_APP = "deleteEcosystemApp";
export const GET_ECOSYSTEM_FORM_DATA = "getEcosystemFormData";
export const SAVE_ECOSYSTEM_FORM = "saveEcosystemForm";
export const GET_ECOSYSTEM_APP_CHECKLIST = "getEcosystemAppChecklist";
export const FETCH_ECOSYSTEM_APPLICATION = "fetchEcosystemApp";
export const GET_STRUCTURE_AND_ORGANIZATION  = "structure_and_organization";
export const UPDATE_ECOSYSTEM_STATUS_APPLICATION = "updateEcosystemStatusApplication";
export const GET_ECOSYSTEM_TEAM  = "getEcosystemTeam";
export const SEND_ECOSYSTEM_INVITATION  = "sendEcosystemInvitation";
export const ECOSYSTEM_RESET_STATE  = "ecosystemResetState";

// FORMBUILDER ACTIONS
export const GET_BUILDER_FORMS  = "getBuilderForms";
export const GET_BUILDER_FORM_DATA  = "getBuilderFormData";

// INVESTOR
export const SAVE_INVESTOR_FORM = "sendInvestorForm";
export const FETCH_INVESTOR_FORM = "fetchInvestorFrom";
export const GET_INVESTOR_DECLARATION = "getInvestorDeclaration";
export const DOWNLOAD_INVESTOR_DECLARATION = "downloadInvestorDeclaration";

// SESSIONLESS APPLICATIONS
export const FETCH_SESSIONLESS_APP_BY_APP_TYPE = "fetchSessionlessAppByAppType";

// DECLARATIONS ACTIONS
export const DECLARATION_FORM_GET = "declarationFormGet";
export const DECLARATION_FORM_SAVE = "declarationFormSave";